import ViewController from '../ViewController'

import lightenColor from '../helpers/lightenColor'

const createControl = (button, className) => {
  const controlUI = document.createElement('div')

  if (button.type === 'menu') {
    controlUI.innerHTML = `${button.displayName}`
    controlUI.addEventListener('click', ViewController.onMenuClick)
  }

  if (button.type === 'filter') {
    controlUI.innerHTML = button.displayName
    controlUI.setAttribute('data-value', button.code)
    controlUI.addEventListener('click', ViewController.onFilterClick)
  }

  // style inline by config-value for color
  const backgroundColor = lightenColor(
    button.color.toString(),
    '0.9'
  )
  controlUI.style.backgroundColor = backgroundColor

  controlUI.setAttribute('class', className)

  return controlUI
}

export default createControl



// WEBPACK FOOTER //
// ./src/mapSetup/createControls.js